// src/main.js

import './style.css';
import logo from '/img/logo.svg';
import { renderTestButtons, exposeTestFunctions } from './utils/test-utils';

// Development buttons HTML
const devButtons =
  process.env.NODE_ENV === 'development' ? renderTestButtons() : '';

// Main app HTML
document.querySelector('#app').innerHTML = /* HTML */ `
  <div class="flex min-h-screen items-center justify-center bg-gray-50">
    <div class="mx-auto w-full max-w-md">
      <div class="rounded-xl bg-white p-8 shadow-sm">
        <!-- Logo and Title Row -->
        <div class="flex items-center justify-center gap-3">
          <img src="${logo}" alt="SourceLink Logo" class="h-10 w-10" />
          <h1 class="text-4xl font-bold text-slate-500">SourceLink</h1>
        </div>

        <!-- Navigation Links -->
        <div class="mt-6 flex items-center justify-center gap-4">
          <a
            href="https://sourcelink.app"
            class="text-sm text-slate-400 hover:text-primary-400">
            Home
          </a>
          <span class="text-gray-300">|</span>
          <a
            href="https://my.sourcelink.app"
            class="text-sm text-slate-400 hover:text-primary-400">
            Login
          </a>
        </div>

        <!-- Development Buttons -->
        ${devButtons}
      </div>
    </div>
  </div>
`;

// Expose test functions to window object in development mode
if (process.env.NODE_ENV === 'development') {
  exposeTestFunctions();
}
